const jai = {
  name: 'Jai',
  spdMod: 0.083,
  crtMod: 0,
  stsMod: 0,
  dmgMod: -4,
  img: 'jai'
}

const ruhang = {
  name: 'Ruhang',
  spdMod: -0.067,
  crtMod: 0,
  stsMod: 0,
  dmgMod: 14,
  img: 'ruhang'
}

const jai2 = {
  name: 'Jai II',
  spdMod: 0.167,
  crtMod: 0,
  stsMod: 0,
  dmgMod: -8,
  img: 'jai-2'
}

const ruhang2 = {
  name: 'Ruhang II',
  spdMod: -0.133,
  crtMod: 0,
  stsMod: 0,
  dmgMod: 28,
  img: 'ruhang-2'
}

const vargeetJai = {
  name: 'Vargeet Jai',
  spdMod: 0.083,
  crtMod: 7,
  stsMod: -4,
  dmgMod: -4,
  img: 'vargeet-jai'
}

const vargeetRuhang = {
  name: 'Vargeet Ruhang',
  spdMod: -0.067,
  crtMod: 7,
  stsMod: -4,
  dmgMod: 14,
  img: 'vargeet-ruhang'
}

const ekwanaJai = {
  name: 'Ekwana Jai',
  spdMod: 0.083,
  crtMod: -4,
  stsMod: 7,
  dmgMod: -4,
  img: 'ekwana-jai'
}

const ekwanaRuhang = {
  name: 'Ekwana Ruhang',
  spdMod: -0.067,
  crtMod: -4,
  stsMod: 7,
  dmgMod: 14,
  img: 'ekwana-ruhang'
}

const vargeet2Jai = {
  name: 'Vargeet II Jai',
  spdMod: 0.083,
  crtMod: 14,
  stsMod: -8,
  dmgMod: -4,
  img: 'vargeet-2-jai'
}

const vargeet2Ruhang = {
  name: 'Vargeet II Ruhang',
  spdMod: -0.067,
  crtMod: 14,
  stsMod: -8,
  dmgMod: 14,
  img: 'vargeet-2-ruhang'
}

const ekwana2Jai = {
  name: 'Ekwana II Jai',
  spdMod: 0.083,
  crtMod: -8,
  stsMod: 14,
  dmgMod: -4,
  img: 'ekwana-2-jai'
}

const ekwana2Ruhang = {
  name: 'Ekwana II Ruhang',
  spdMod: -0.067,
  crtMod: -8,
  stsMod: 14,
  dmgMod: 14,
  img: 'ekwana-2-ruhang'
}

const vargeetJai2 = {
  name: 'Vargeet Jai II',
  spdMod: 0.167,
  crtMod: 7,
  stsMod: -4,
  dmgMod: -8,
  img: 'vargeet-jai-2'
}

const vargeetRuhang2 = {
  name: 'Vargeet Ruhang II',
  spdMod: -0.133,
  crtMod: 7,
  stsMod: -4,
  dmgMod: 28,
  img: 'vargeet-ruhang-2'
}

const ekwanaJai2 = {
  name: 'Ekwana Jai II',
  spdMod: 0.167,
  crtMod: -4,
  stsMod: 7,
  dmgMod: -8,
  img: 'ekwana-jai-2'
}

const ekwanaRuhang2 = {
  name: 'Ekwana Ruhang II',
  spdMod: -0.133,
  crtMod: -4,
  stsMod: 7,
  dmgMod: 28,
  img: 'ekwana-ruhang-2'
}

const links = [jai, ruhang, jai2, ruhang2, vargeetJai, vargeetRuhang, ekwanaJai, ekwanaRuhang, vargeet2Jai, vargeet2Ruhang, ekwana2Jai, ekwana2Ruhang, vargeetJai2, vargeetRuhang2, ekwanaJai2, ekwanaRuhang2]

export default links
